import * as React from "react";
import { forwardRef } from "react";
const SvgABoxedFilled = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: "1em", viewBox: "0 0 24 24", width: "1em", fill: "currentColor", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M22 2H2V22H22V2ZM13.2526 6H10.7299L6 19H8.55766L9.45109 16.3641H14.3912L15.2847 19H18L13.2526 6ZM11.9212 9.13793L13.673 14.2662H10.1693L11.9212 9.13793Z" }));
const ForwardRef = forwardRef(SvgABoxedFilled);
export { ForwardRef as ReactComponent };
